import {
  MemberEntityTypeKey,
  MemberProfileExtendedType,
} from 'common/types/MemberProfile'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { ReportProfileWizard } from './ReportProfileWizard/ReportProfileWizard'

type ReportProfileProps = {
  className: string
  profile: MemberProfileExtendedType
}

export function ReportProfile({ className, profile }: ReportProfileProps) {
  const [isReportProfileWizardOpen, setIsReportProfileWizardOpen] =
    useState(false)
  const { memberEntity } = useParams<{
    memberEntity: MemberEntityTypeKey
  }>()

  return (
    <>
      <button
        onClick={() => setIsReportProfileWizardOpen(true)}
        className={`${className} text-sm text-[#001A3D] underline underline-offset-4 cursor-pointer`}
      >
        Report profile
      </button>
      <ReportProfileWizard
        memberEntity={memberEntity}
        memberId={profile?.metadata?.id}
        isOpen={isReportProfileWizardOpen}
        handleClose={() => setIsReportProfileWizardOpen(false)}
      />
    </>
  )
}
